// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"whats-new-card_gridContainer__L7krQ"};